import { api } from "@/api";
import { defineStore } from "pinia";
import { ref } from "vue";

interface Settings {
    ppn: number;
}

export const useSettingsStore = defineStore("settings", () => {
    const data = ref<Settings>();

    async function synchronize() {
        const result = await api.settings.clientConfig().execute();
        if (result === undefined) throw new Error("Failed to synchronize settings data");

        data.value = {
            ppn: result.ppn,
        };
    }

    return { data, synchronize };
});
